import React from 'react';
import Icons from '../../../Components/Icons/Icons';
import Buttons from '../../../Components/UI/Buttons';
import SplitViewSideBarToggle from '../../../Components/SplitViewSideBarToggle';
import { isSet } from '../../../Utils/CommonFunctions';
import PaginationLeftNav from "../../../Components/UI/TableRecord/PaginationLeftNav";


const Navbar = (props) => {
	const {toggleNavbar,isNavbarOpen,currentTab,changeTab,toggleCreateVaiableModel,variableList,constantList,deleteVaraibleHandler,editCreateVaiableModel,editVariableHandler} = props;
	let fieldTypeCardDisplay = 'none';
    if(props.isHiddenCardBoxShow === true){
      fieldTypeCardDisplay = 'block';
    }
    let fieldTypeCss = {"position":"absolute","min-width":"200px","zIndex":6,"left":"5px","right":"auto","backgroundColor":"rgb(255, 255, 255)","display":fieldTypeCardDisplay}

	return (
		<SplitViewSideBarToggle>
				<div className="filter_Header py-0 px-0">
					<div className="d-flex border-bottom">
						<ul className="nav nav-pills navcrm-primary nav-pills-no-bd">
							<li className="nav-item pl-2 cursor-pointer">	
								<a className={currentTab === "variable" ? 'nav-link show active' : 'nav-link'} onClick={e=>changeTab('variable')}> Variables & Resource </a>
							</li>
							{/*<li className="nav-item cursor-pointer">	
								<a className={currentTab === "constant" ? 'nav-link show active' : 'nav-link'} onClick={e=>changeTab('constant')}> Constant </a>
							</li>*/}
						</ul>
					</div>
					<div className="d-flex align-items-center justify-content-between">
						<div className="pr-0 cursor-pointer">
							<form onSubmit={props.submitSearch}>
							<div className="nav-item dropdown search-dropdown">
								<a data-toggle="dropdown" className="nav-item nav-link dropdown-toggle hidden-caret" href="#">	
									<i className="fa fa-search secondary_color"></i>
								</a>
								<a data-toggle="dropdown" className="nav-item nav-link dropdown-toggle d-none hidden-caret" href="#">	
									<i className="fas fa-times primary_color"></i>
								</a>
								<div className="dropdown-menu">											
									
									<div className="input-group search-box">
										<input type="text" id="search" value={props.variableTable.pagination.search} onChange={(e)=> props.updateSearchState(e)} className="form-control" placeholder="Search here..." />
									</div>
									
								</div>
							</div>
							</form>
						</div>
						<div className="pr-2">
							<div className="selectgroup ">
								<div className="selectgroup-item " onClick={toggleCreateVaiableModel}>	<span className="selectgroup-button selectgroup-button-icon primary_bg" data-title="Add New">
									<Icons iconType="AddPlus" />
								</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				{props.response ? <>
				<div className="filter_Body p-0">
					<div className="table-responsive">
						<table className="table table-striped">
							<thead>
								<tr className="text-small">
					              <th></th>
					              <th>Variable Name</th>
					              <th>
					                <a className="cursor-pointer" onClick={props.cardHiddenBoxHandler}><span><Icons iconType="InfoIcon" /> Field Type </span></a>
					                <div className="card hidden_Box animated fadeIn" style={fieldTypeCss}>
					                  <div className="card-header p-0">
					                    <div id="close-sidebar" className="icon-right" style={{"right":"2px","top":"2px","opacity":"0.3"}} onClick={()=>props.cardHiddenBoxHandler()}><i className="fa fa-times-circle fa-lg"></i></div>
					                  </div>
					                  <div className="card-body">
					                    <div className="d-inline ">
					                      <div className="text-medium mb-2"><span className="inputBox mr-1"></span>Input Variable</div>                      
					                      <div className="text-medium mb-2"><span className="outputBox mr-1"></span>Output Variable</div>                      
					                      <div className="text-medium"><span className="constanttBox mr-1"></span>Constant</div>
					                     </div>
					                  </div>                          
					                </div>
					              </th>
					            </tr>
							</thead>

							<tbody> 
					            {[...isSet(variableList,[]),...isSet(constantList,[])].map((item,itemIndex)=>{

					              let deleteButton = {}
					              if(isSet(item.default,false)===false){
					                deleteButton = {
					                  svgIcon:'Delete',
					                    title:'',
					                  clickHandler:()=>deleteVaraibleHandler(item.id) 
					                }
					              }
					              

					              const buttonList = [
					                {
					                  svgIcon:'Edit',
					                  title:'',
					                  clickHandler:()=>editVariableHandler(item),
					                },
					                {...deleteButton}
					                // {
					                //   svgIcon:'Delete',
					                //   title:'',
					                //   clickHandler:()=>deleteVaraibleHandler(item.id)
					                // }
					              ]

					              let inputClass = 'inputValue';
					              if(item.is_constant === true){
					                inputClass = 'constantValue';
					              }else if(item.is_response === true){
					                inputClass = 'outputValue';
					              }

					              // if(item.is_constant===false){
					                return(
					                  <tr key={itemIndex}>
					                    <td><Buttons buttonList={buttonList} /></td>
					                    <td>{item.variable_name}</td>
					                    <td className="position-relative">
					                      <div className={`tbodyTitle ${inputClass}`}>{item.fieldtype_name}
					                        <span className="text-dark text-medium ml-1" style={{opacity:'0.5',fontStyle:'italic'}}>({item.function_type})</span>
					                      </div>
					                    </td>
					                    {/*<td>{(item.is_constant===true)?'CONSTANT':'VARIABLE'}</td>*/}
					                  </tr>
					                )
					              // }
					            })}
					          </tbody>

							{/*
							currentTab === "variable" ?
				              <tbody> 
				              {
				                variableList && variableList.length > 0 ? 
				                    variableList.map((arr,i) => {
				                      const buttonList = [
				                        {
				                          svgIcon:'Delete',
				                          title:'',
				                          clickHandler:(e)=>deleteVaraibleHandler(arr.id)
				                        }
				                      ]
				                      return (
				                          <tr>
				                            <td>
				                              <Buttons buttonList={buttonList} />
				                            </td>
				                            <td>
				                              <div className="tbodyTitle">{arr.fieldtype_name}</div>
				                            </td>
				                            <td>
				                              <div className="tbodyTitle">{arr.variable_name}</div>
				                            </td>
				                          </tr>
				                        )
				                    })
				                : <tr className="bg-light"><td colSpan="3" className="text-small text-center">No records found</td></tr>
				              }
				              </tbody>
				              : 
				                <tbody> 
				                {
				                  constantList && constantList.length>0 ? 
				                      constantList.map((arr,i) => {
				                        const buttonList = [
				                          {
				                            svgIcon:'Edit',
				                            title:'',
				                            clickHandler:e=>editCreateVaiableModel(arr)
				                          },
				                          {
				                            svgIcon:'Delete',
				                            title:'',
				                            clickHandler:(e)=>deleteVaraibleHandler(arr.id)
				                          }
				                        ]
				                        return (
				                          <tr key={i}>
				                            <td>
				                              <Buttons buttonList={buttonList} />
				                            </td>
				                            <td>
				                              <div className="tbodyTitle">{arr.fieldtype_name}</div>
				                            </td>
				                            <td>
				                              <div className="tbodyTitle">{arr.variable_name}</div>
				                            </td>
				                          </tr>
				                          )
				                      })
				                  : <tr className="bg-light"><td colSpan="3" className="text-small text-center">No records found</td></tr>
				                }
				                </tbody>
				              */}


						</table>
					</div>
				</div>
				<div className="filter_Footer">
              <div className="dataTables_length p-2">
                <label className="pl-0"> Total Records: <span className="badge badge-warning secondary_color">
                {
                   props.variableTable.pagination.totalRecords ?
                    props.variableTable.pagination.totalRecords
                    : 0
                }
                </span>
                </label>
              </div>

              {
                props.variableTable.pagination.perPage ?
                <PaginationLeftNav page={props.variableTable.pagination.page} search={props.variableTable.pagination.search} perPage={props.variableTable.pagination.perPage} totalRecords={props.variableTable.pagination.totalRecords}
                  recordsChangeHandler={props.recordsChangeHandler}
                />
                :
                ''
              }

            </div>
				 </>
				: <> <div className="filter_Body p-0">
				<div className="table-responsive">
				  <table className="table table-striped">
					<tr className="text-small card-body pt-0">
					  <td>No Record Found</td>
					</tr>
					</table>
					</div>
					</div>
					<div className="filter_Footer">
			  <div className="dataTables_length p-2">
				<label className="pl-0"> <span className="badge badge-warning secondary_color">
			       0
				</span>
				</label>
			  </div>
			  </div>
			  </>
			  }
		</SplitViewSideBarToggle>
	)
}

export default Navbar;